import {
  type ExchangeRateMap,
  type ExchangeUnit,
  ExchangeUnitSchemaMap,
  type ToExchangeValue,
} from '@mntn-dev/domain-types'

export const DEFAULT_EXCHANGE_RATES: ExchangeRateMap = {
  DB: 1, // units stored in the database are DB
  USD: 100,
  mntn_credits: 50000, // 1 MNTN credit = 500 USD
  meta: 100,
  tiktok: 100,
  linkedin: 100,
}

/**
 * Converts an amount from one ExchangeUnit to another using the provided exchange rates
 * @param amount The amount to convert
 * @param fromUnit The source unit
 * @param toUnit The target unit
 * @param exchangeRates Map of exchange rates (each unit to its DB value)
 * @returns The converted amount in the target unit
 */
export function convertExchangeUnits<
  F extends ExchangeUnit,
  T extends ExchangeUnit,
>(
  amount: number,
  fromUnit: F,
  toUnit: T,
  exchangeRates: ExchangeRateMap = DEFAULT_EXCHANGE_RATES
): ToExchangeValue<T> {
  // If units are the same, no conversion needed
  if ((fromUnit as ExchangeUnit) === (toUnit as ExchangeUnit)) {
    return amount as unknown as ToExchangeValue<T>
  }

  const fromRate = exchangeRates[fromUnit]
  const toRate = exchangeRates[toUnit]

  const baseValue = (amount as number) * fromRate
  const converted = baseValue / toRate

  // Convert from DB to target unit
  return ExchangeUnitSchemaMap[toUnit].parse(converted) as ToExchangeValue<T>
}
